import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SideBar from '../SideBar/SideBar';
import Header from '../Header/Header';
import { fetchAndStoreMultipleDevicesTodayData } from '../redux/action/totalData';
import Loading from '../common/Loading';
import store from '../redux';
import { loadUnitSnapshot } from '../redux/action/dailyUnit';
import { selectedHouse as selectedHouseFromDropdown, selectedDeviceType, selectedRoomDevices, selectedDeviceFromDropdown } from '../redux/action/deviceDropdownSelection';
import MainV2 from './MainV2';
import { deviceTypeGroups, groupOfDevice, keptSelection } from './selection';
import { housesListAction } from '../redux/action/housesList';
import { selectedHouse } from '../redux/actionTypes';
import { useParams } from 'react-router-dom';
import DashBoard from '../DashBoard/DashBoard';
// Page shell. Pages sit beside the sidebar (AppLayout), so they fill what is
// left of the window rather than the whole of it.
export const styles = {
  container: {
    height: '100vh',
    width: '100%',
    display: 'flex',
  },
  rightContainer: {
    height: '100vh',
    width: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
};
function MainPage() {
  const params = useParams()
  const { selectedDeviceDetails: { deviceId: selectedDeviceId } = {}, devices } = useSelector(state => state.dropdownSelectionData);
  const houseData = useSelector(state => state.houseData);
  const [loading, setLoading] = useState(false);
  const [dateA, setDateA] = useState(new Date());
  const [roomCount, setRoomCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (Object.keys(houseData).length === 0) return;
      store.dispatch(selectedHouseFromDropdown(houseData._id))
      // The date range is left alone. This runs on every store switch, and
      // resetting only the start date to today left the range ending before it
      // began whenever a past date was picked - an empty range, so no data was
      // fetched. MainV2 sets today's range itself when the page opens.
      // The Device Type dropdown's groups: every device in the store, by type.
      const groups = deviceTypeGroups(houseData?.rooms ?? []);
      if (groups.length === 0) return;
      setRoomCount(groups.length)

      // Coming back to the dashboard (from another page, or after a reload)
      // keeps the type and appliance picked before, as long as this store still
      // has them. Read from the store rather than the hook values above so a
      // pick made since the last render counts. A deep link names its own
      // device, so it is opened under that device's type instead.
      const deepLinked = Object.keys(params).length !== 0;
      const picked = deepLinked
        ? groupOfDevice(groups, params.deviceId)
        : keptSelection(groups, store.getState().dropdownSelectionData);
      const { group, device } = picked ?? { group: groups[0], device: groups[0].devices[0] };

      store.dispatch(selectedDeviceType(group.key));
      store.dispatch(selectedRoomDevices(group.devices));
      store.dispatch(selectedDeviceFromDropdown(device));
    };

    fetchData();

    // Cleanup function
    return () => {
      // Add any necessary cleanup logic here if needed in the future
    };
  }, [houseData,params]);

  return (
    <div style={{ ...styles.container }}>
      {/* <SideBar /> */}
      <div style={{ ...styles.rightContainer }}>
        <Header />
        <MainV2 setLoading={setLoading} dateA={dateA} setDateA={setDateA} setRoomCount={setRoomCount} roomCount={roomCount} />
      </div>
      {loading && <Loading />}
    </div>
  );
}

export default MainPage;
